import React from 'react';
interface FlipCardProps {
  frontContent: React.ReactNode;
  backContent: React.ReactNode;
  className?: string;
  link?: string;
}
export function FlipCard({
  frontContent,
  backContent,
  className = '',
  link
}: FlipCardProps) {
  const Wrapper = link ? 'a' : 'div';
  const wrapperProps = link ? {
    href: link,
    target: '_blank' as const,
    rel: 'noopener noreferrer'
  } : {};
  return <Wrapper className={`flip-card group h-[450px] w-full block ${className}`} tabIndex={0} {...wrapperProps} data-id="element-120">
      <div className="flip-card-inner" data-id="element-121">
        <div className="flip-card-front bg-white" data-id="element-122">{frontContent}</div>
        <div className="flip-card-back bg-white" data-id="element-123">{backContent}</div>
      </div>
    </Wrapper>;
}